export default "__VITE_ASSET__DhVZX1J7__"